import { diffLines } from 'diff';
import { range } from 'lodash';

export function getDiffLineNumbers(
  baseText: string,
  newText: string,
): {
  added: number[];
  removed: number[];
  modified: number[];
} {
  const { added, removed, modified } = diffLines(baseText, newText).reduce(
    (
      acc: {
        currentLineNumber: number;
        added: number[];
        removed: number[];
        modified: number[];
      },
      line,
      i,
      diffArr,
    ) => {
      const groupEndLineNumber = acc.currentLineNumber + (line.count ?? 0);
      // In cases where we have removed -> added, this is a modification
      // The modification length is only as long as the number of added lines in the grouping.
      if (line.removed && diffArr[i + 1] && diffArr[i + 1]?.added) {
        return {
          ...acc,
          modified: [
            ...acc.modified,
            ...range(
              acc.currentLineNumber,
              acc.currentLineNumber + (diffArr[i + 1]?.count ?? 0),
            ),
          ],
        };
      } else if (line.added && diffArr[i - 1] && diffArr[i - 1]?.removed) {
        return {
          ...acc,
          currentLineNumber: groupEndLineNumber,
        };
      } else if (line.removed) {
        return {
          ...acc,
          // Even though many lines may be removed we only want to mark the first line of
          // each group of consecutive lines as deleted. Also if the previous line is marked
          // as modified, we should only show the modified dot and not the removed dot.
          removed: [...acc.removed, acc.currentLineNumber],
        };
      } else if (line.added) {
        return {
          ...acc,
          currentLineNumber: groupEndLineNumber,
          added: [
            ...acc.added,
            ...range(acc.currentLineNumber, groupEndLineNumber),
          ],
        };
      }
      return {
        ...acc,
        currentLineNumber: groupEndLineNumber,
      };
    },
    { currentLineNumber: 1, added: [], removed: [], modified: [] },
  );

  return {
    added,
    removed,
    modified,
  };
}
